export const LOGGING_LEVEL = ['panic', 'fatal', 'error', 'warning', 'info', 'debug'] as const;

export const STATS_TYPE = ['prometheus', 'graphite'] as const;

export const ON_OFF = ['On', 'Off'] as const;

export const TRUE_FALSE = ['True', 'False'] as const;

export const LOGGING_FORMAT = ['text', 'json'] as const;

export const STATIC_MAP_NETWORK = ['ip', 'ip4', 'ip6'] as const;

export const LOGGING_TIMESTAMP_ITEMS = [
  { label: 'Layout', value: "01/02 03:04:05PM '06 -0700" } as const,
  { label: 'ANSIC', value: 'Mon Jan _2 15:04:05 2006' } as const,
  { label: 'Unix Date', value: 'Mon Jan _2 15:04:05 MST 2006' } as const,
  { label: 'Ruby Date', value: 'Mon Jan 02 15:04:05 -0700 2006' } as const,
  { label: 'RFC822', value: '02 Jan 06 15:04 MST' } as const,
  { label: 'RFC822Z', value: '02 Jan 06 15:04 -0700' } as const,
  { label: 'RFC850', value: 'Monday, 02-Jan-06 15:04:05 MST' } as const,
  { label: 'RFC1123', value: 'Mon, 02 Jan 2006 15:04:05 MST' } as const,
  { label: 'RFC1123Z', value: 'Mon, 02 Jan 2006 15:04:05 -0700' } as const,
  { label: 'RFC3339', value: '2006-01-02T15:04:05Z07:00' } as const,
  { label: 'RFC3339 Nano', value: '2006-01-02T15:04:05.999999999Z07:00' } as const,
  { label: 'Kitchen', value: '3:04PM' } as const,
  { label: 'Stamp', value: 'Jan _2 15:04:05' } as const,
  { label: 'Stamp Milli', value: 'Jan _2 15:04:05.000' } as const,
  { label: 'Stamp Micro', value: 'Jan _2 15:04:05.000000' } as const,
  { label: 'Stamp Nano', value: 'Jan _2 15:04:05.000000000' } as const,
];

export type LoggingTimestampValue = (typeof LOGGING_TIMESTAMP_ITEMS)[number]['value'];
export type LoggingTimestampLabel = (typeof LOGGING_TIMESTAMP_ITEMS)[number]['label'];
